import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import {
  FaTachometerAlt,
  FaTasks,
  FaUserAlt,
  FaTools,
  FaRegCommentDots,
  FaMoneyBillAlt,
  FaBox,
  FaClipboardList,
  FaFileAlt,
  FaUsers,
  FaCalendarAlt,
  FaMapMarkerAlt,
  FaUserFriends,
  FaBuilding,
  FaCog,
  FaWrench,
  FaChevronRight,
  FaChevronDown,
  FaUserShield,
  FaEllipsisV,
} from "react-icons/fa";
import "./Sidebar.css";

const Sidebar = () => {
  const permissions = useSelector((state) => state.permissions); // Adjust based on your reducer path

  const navigate = useNavigate();
  // const [activeMenu, setActiveMenu] = useState("dashboard"); // Default active menu
  const location = useLocation();
  const currentPath = location.pathname;
  const handleNavigation = (route) => {
    navigate(route);
  };

  const [isAdminOpen, setIsAdminOpen] = useState(false);
  const toggleAdminMenu = () => setIsAdminOpen(!isAdminOpen);

  const [isStockOpen, setIsStockOpen] = useState(false);
  const toggleStockMenu = () => setIsStockOpen(!isStockOpen);
  //Task router
  const taskRoutes = [
    "/task",
    "/createtask",
    "/mytask",
    "/taskmapview",
    "/tasklistview",
    "/taskcard",
    "/taskcard1",
    "/viewtask",
    "/taskprocess",
    "/view_createtask",
    "/recurring",
    "/addrecurring",
    "/viewrecurring",
  ];
  const isTaskActive = taskRoutes.some((r) => currentPath.startsWith(r));
  //enquiry routes
  const enquiryRoutes = [
    "/enquiry", // base enquiry page
    "/addenquiry", // add form
    "/view_enquiry", // viewe form
  ];

  const isEnquiryActive = enquiryRoutes.some((r) => currentPath.startsWith(r));
  //installation routes
  const installationRoutes = [
    "/installation",
    "/add_installation",
    "/view_installation",
  ];

  const isInstallationActive = installationRoutes.some((r) =>
    currentPath.startsWith(r)
  );
  //complaint routes
  const complaintRoutes = ["/complaint", "/add_complaint", "/view_complaint"];

  const isComplaintActive = complaintRoutes.some((r) =>
    currentPath.startsWith(r)
  );
  //Dues routes
  const duesRoutes = ["/duessection", "/adddues", "/view_dues"];

  const isDuesActive = duesRoutes.some((r) => currentPath.startsWith(r));
  // Stock routes
  const stockMainRoutes = ["/stock", "/addstock", "/plusstock"];
  const isStockActive = stockMainRoutes.some((r) => currentPath.startsWith(r));
  // managetask submenu Routes
  const isStockSubmenuActive = currentPath.startsWith("/managestock");
  // Recovery routes
  const recoveryRoutes = ["/recovery", "/addrecovery", "/viewrecovery"];

  const isRecoveryActive = recoveryRoutes.some((r) =>
    currentPath.startsWith(r)
  );
  // Administration routes
  const adminMainRoutes = ["/administrationsection"];
  const isAdminActive = adminMainRoutes.some((r) => currentPath.startsWith(r));
  // Roles submenu active check
  const isAdminSubmenuActive = currentPath.startsWith("/roles");
  // Staff routes
  const staffRoutes = ["/staffsection", "/addstaff", "/editStaff"];

  const isStaffActive = staffRoutes.some((r) => currentPath.startsWith(r));
  // Customer routes
  const customerRoutes = [
    "/customersection",
    "/add_customer",
    "/view_customer",
    "/edit_customer",
  ];

  const isCustomerActive = customerRoutes.some((r) =>
    currentPath.startsWith(r)
  );
  //settings routes
  const settingsRoutes = ["/settingssection", "/ottdetails", "/leadsource"];

  const isSettingsActive = settingsRoutes.some((r) =>
    currentPath.startsWith(r)
  );

  return (
    <div className="sidebar-container">
      <div className="sidebar">
        <div className="logo">Help Desk</div>

        <ul className="menu">
          {permissions?.["Side Bar"]?.Dashboard?.Read && (
            <li
              className={`menu-item ${
                currentPath.startsWith("/dashboard") ? "active" : ""
              }`}
              onClick={() => handleNavigation("/dashboard")}
            >
              <FaTachometerAlt className="icon" />
              <span className="items">Dashboard</span>
            </li>
          )}

          {permissions?.["Side Bar"]?.Task?.Read && (
            <li
              className={`menu-item ${isTaskActive ? "active" : ""}`}
              onClick={() => handleNavigation("/task")}
            >
              <FaTasks className="icon" />
              <span className="items">Task</span>
            </li>
          )}

          {permissions?.["Side Bar"]?.Enquiry?.Read && (
            <li
              className={`menu-item ${isEnquiryActive ? "active" : ""}`}
              onClick={() => handleNavigation("/enquiry")}
            >
              <FaUserAlt className="icon" />
              <span className="items">Enquiry</span>
            </li>
          )}

          {permissions?.["Side Bar"]?.Installation?.Read && (
            <li
              className={`menu-item ${isInstallationActive ? "active" : ""}`}
              onClick={() => handleNavigation("/installation")}
            >
              <FaTools className="icon" />
              <span className="items">Installation</span>
            </li>
          )}

          {permissions?.["Side Bar"]?.Complaints?.Read && (
            <li
              className={`menu-item ${isComplaintActive ? "active" : ""}`}
              onClick={() => handleNavigation("/complaint")}
            >
              <FaRegCommentDots className="icon" />
              <span className="items">Complaint</span>
            </li>
          )}

          {permissions?.["Side Bar"]?.Dues?.Read && (
            <li
              className={`menu-item ${isDuesActive ? "active" : ""}`}
              onClick={() => handleNavigation("/duessection")}
            >
              <FaMoneyBillAlt className="icon" />
              <span className="items">Dues</span>
            </li>
          )}

          {/* // STOCK MAIN MENU */}
          {permissions?.["Side Bar"]?.Stock?.Read && (
            <li
              className={`menu-item ${isStockActive ? "active" : ""}`}
              onClick={() => handleNavigation("/stock")}
            >
              <FaBox className="icon" />
              <span className="items">Stock</span>

              {isStockOpen ? (
                <FaChevronDown
                  className="icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleStockMenu();
                  }}
                />
              ) : (
                <FaChevronRight
                  className="icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleStockMenu();
                  }}
                />
              )}
            </li>
          )}
          {/* // STOCK SUBMENU (only visible when arrow clicked OR pathname matches subtab) */}
          {(isStockOpen || isStockSubmenuActive) && (
            <ul className="submenu">
              <li
                className={`menu-item ${isStockSubmenuActive ? "active" : ""}`}
                onClick={() => handleNavigation("/managestock")}
              >
                <FaEllipsisV className="icon-stock" />
                <span className="items-stock">Manage Stock</span>
              </li>
            </ul>
          )}

          {permissions?.["Side Bar"]?.Recovery?.Read && (
            <li
              className={`menu-item ${isRecoveryActive ? "active" : ""}`}
              onClick={() => handleNavigation("/recovery")}
            >
              <FaClipboardList className="icon" />
              <span className="items">Recovery</span>
            </li>
          )}

          {permissions?.["Side Bar"]?.["Customer Reports"]?.Read && (
            <li
              className={`menu-item ${
                currentPath.startsWith("/customerreportsection") ? "active" : ""
              }`}
              onClick={() => handleNavigation("/customerreportsection")}
            >
              <FaFileAlt className="icon" />
              <span className="items">Customer Report</span>
            </li>
          )}

          {permissions?.["Side Bar"]?.["Staff Analysis"]?.Read && (
            <li
              className={`menu-item ${
                currentPath.startsWith("/staffanalysissection") ? "active" : ""
              }`}
              onClick={() => handleNavigation("/staffanalysissection")}
            >
              <FaUsers className="icon" />
              <span className="items">Staff Analysis</span>
            </li>
          )}

          {permissions?.["Side Bar"]?.Attendance?.Read && (
            <li
              className={`menu-item ${
                currentPath.startsWith("/attendancesection") ? "active" : ""
              }`}
              onClick={() => handleNavigation("/attendancesection")}
            >
              <FaCalendarAlt className="icon" />
              <span className="items">Attendance</span>
            </li>
          )}

          {permissions?.["Side Bar"]?.Location?.Read && (
            <li
              className={`menu-item ${
                currentPath.startsWith("/locationsection") ? "active" : ""
              }`}
              onClick={() => handleNavigation("/locationsection")}
            >
              <FaMapMarkerAlt className="icon" />
              <span className="items">Location</span>
            </li>
          )}

          {permissions?.["Side Bar"]?.Staffs?.Read && (
            <li
              className={`menu-item ${isStaffActive ? "active" : ""}`}
              onClick={() => handleNavigation("/staffsection")}
            >
              <FaUserFriends className="icon" />
              <span className="items">Staffs</span>
            </li>
          )}

          {permissions?.["Side Bar"]?.Customers?.Read && (
            <li
              className={`menu-item ${isCustomerActive ? "active" : ""}`}
              onClick={() => handleNavigation("/customersection")}
            >
              <FaBuilding className="icon" />
              <span className="items">Customers</span>
            </li>
          )}

          {/* // ADMINISTRATION MAIN MENU */}
          {permissions?.["Side Bar"]?.Administration?.Read && (
            <li
              className={`menu-item ${isAdminActive ? "active" : ""}`}
              onClick={() => handleNavigation("/administrationsection")}
            >
              <FaCog className="icon" />
              <span className="items">Administration</span>

              {isAdminOpen ? (
                <FaChevronDown
                  className="icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleAdminMenu();
                  }}
                />
              ) : (
                <FaChevronRight
                  className="icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleAdminMenu();
                  }}
                />
              )}
            </li>
          )}
          {/* // ADMINISTRATION SUBMENU: ROLES */}
          {(isAdminOpen || isAdminSubmenuActive) && (
            <ul className="submenu">
              <li
                className={`menu-item ${isAdminSubmenuActive ? "active" : ""}`}
                onClick={() => handleNavigation("/roles")}
              >
                <FaUserShield className="icon-admin" />
                <span className="items-admin">Roles</span>
              </li>
            </ul>
          )}

          {permissions?.["Side Bar"]?.Settings?.Read && (
            <li
              className={`menu-item ${isSettingsActive ? "active" : ""}`}
              onClick={() => handleNavigation("/settingssection")}
            >
              <FaWrench className="icon" />
              <span className="items">Settings</span>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
